import { Box, SxProps, Theme, useTheme } from '@mui/material';

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    root: {
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      border: '2px solid #E27816',
      pointerEvents: 'none',
      zIndex: 999,
      '& .label': {
        position: 'absolute',
        left: '50%',
        top: '-2px',
        fontSize: '1rem',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        display: 'inline-block',
        background: '#e27816',
        color: '#fff',
        padding: '3px 10px',
        transform: 'translateX(-50%)',
        borderRadius: '0 0 5px 5px',
      },
    },
  };
};

export default function LoginAsOverlay() {
  const theme = useTheme();
  const styles = getStyles(theme);
  return (
    <Box sx={styles.root}>
      <span className="label">Logged in as user</span>
    </Box>
  );
}
